import React from 'react';
import './allservices.css';
import { Helmet } from "react-helmet";
import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import { useNavigate } from "react-router-dom";
import Image1 from '../../Assets/Piercing Services/ear lobe piercing.png';
import Image2 from '../../Assets/Piercing Services/baby piercing.png';
import Image3 from '../../Assets/Piercing Services/ear second lobe piercing.png';
import Image4 from '../../Assets/Piercing Services/upper lobe piercing.png';
import Image5 from '../../Assets/Piercing Services/high lobe piercing.png';
import Image6 from '../../Assets/Piercing Services/stack lobe piercing (2).png';
import Image7 from '../../Assets/Piercing Services/nose piercing.png';
import Image8 from '../../Assets/Piercing Services/double nose piercing.png';
import Image9 from '../../Assets/Piercing Services/belly piercing (2).png';
import Image10 from '../../Assets/Piercing Services/tongue piercing (2).png';
import Image11 from '../../Assets/Piercing Services/septum piercing (2).png';
import Image12 from '../../Assets/Piercing Services/smiley piercing (2).png';
import Image13 from '../../Assets/Piercing Services/eye brow piercing (2).png';
import Image14 from '../../Assets/Piercing Services/tragus piercing (2).png';
import Image15 from '../../Assets/services/15 Double Tragus Piercing.jpeg';
import Image16 from '../../Assets/Piercing Services/industrial piercing.png';
import Image17 from '../../Assets/Piercing Services/helix piercing.png';
import Image18 from '../../Assets/Piercing Services/double helix piercing.png';
import Image19 from '../../Assets/services/19 MidHelix Piercing.jpeg';
import Image20 from '../../Assets/Piercing Services/triple helix piercing (2).png';
import Image21 from '../../Assets/Piercing Services/hidden helix piercing (2).png';
import Image22 from '../../Assets/Piercing Services/forward helix piercing.png';
import Image23 from '../../Assets/Piercing Services/double forward helix piercing.png';
import Image24 from '../../Assets/Piercing Services/triple  forward helix piercing.png';
import Image25 from '../../Assets/Piercing Services/rook piercing.png';
import Image26 from '../../Assets/Piercing Services/faux rook piercing.png';
import Image27 from '../../Assets/Piercing Services/Flatpiercing.png';
import Image28 from '../../Assets/Piercing Services/double flat piercing.png';
import Image29 from '../../Assets/Piercing Services/triple flat piercing (2).png';
import Image30 from '../../Assets/Piercing Services/Daithpiercing.png';
import Image31 from '../../Assets/Piercing Services/snake bite midi piercing.png';
import Image32 from '../../Assets/Piercing Services/Conch piericng.png';
import Image33 from '../../Assets/Piercing Services/Contra conch Piercing.png';
import Image34 from '../../Assets/Piercing Services/orbital piercing (2).png';
import Image35 from '../../Assets/Piercing Services/snug piercing (2).png';
import Image36 from '../../Assets/Piercing Services/surface tragus piercing.png';
import Image37 from '../../Assets/Piercing Services/anti tragus piercing (2).png';
import Image38 from '../../Assets/Piercing Services/lip piercing (3).png';
import Image39 from '../../Assets/Piercing Services/lip snake bite piercing.png';
import Image40 from '../../Assets/Piercing Services/Ashly piercing.png';
import Image41 from '../../Assets/Piercing Services/medusa lip piercing.png';
import Image42 from '../../Assets/Piercing Services/monroe lip piercing.png';
import Image43 from '../../Assets/Piercing Services/vertical labret lip piercing.png';
import Image44 from '../../Assets/Piercing Services/cheek dimple piercing.png';
import Image45 from '../../Assets/Piercing Services/Tonguewebpiercing.png';
import Image46 from '../../Assets/Piercing Services/snake eye tongue piercing.png';
import Image47 from '../../Assets/Piercing Services/nipple piercing.png';
import Image48 from '../../Assets/Piercing Services/Chestsurfacepiercing.png';
import Image49 from '../../Assets/Piercing Services/chest surface piercing (2).png';
import Image50 from '../../Assets/Piercing Services/Finger dermal piercing.png';
import Image51 from '../../Assets/Piercing Services/face dermal piercing.png';
import Image52 from '../../Assets/Piercing Services/Hand wrist dermal.png';
import Image53 from '../../Assets/Piercing Services/back dimple dermal piercing.png';
import Image54 from '../../Assets/Piercing Services/nape piercing.png';
import Image55 from '../../Assets/Piercing Services/color born piercing.png';
import Image56 from '../../Assets/Piercing Services/Dermal piercing.png';
import Image57 from '../../Assets/Piercing Services/nape piercing (2).png';
import Image58 from '../../Assets/Piercing Services/Bugadi piercing.jpg';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function Services() {

    const navigate = useNavigate();

  return (
    <div id="services" className="allservices-container">
      <Helmet>
        <title>Services - Piercing Service UAE | Best piercing in Dubai UAE</title>
        <meta name="description" content="We offer professional and hygienic piercing service in the UAE, including shop and home services for a safe and comfortable experience" />
				<meta name="keywords" content="ear piercing, nose piercing, lip piercing, tongue piercing, eyebrow piercing, belly button piercing, navel piercing, helix piercing, conch piercing, rook piercing, daith piercing, tragus piercing, industrial piercing, cartilage piercing, septum piercing, medusa piercing, snake bite piercing, labret piercing, smiley piercing, dimple piercing, nipple piercing, dermal piercing, surface piercing, microdermal piercing, bridge piercing, orbital piercing, anti-tragus piercing, snug piercing, high-lobe piercing, custom piercing, jewelry piercing, gold piercing, titanium piercing, piercing jewelry, piercing studs, piercing rings, piercing healing, piercing aftercare, safe piercing, painless piercing, luxury piercing, best piercing studio UAE, Dubai piercing, Abu Dhabi piercing, Sharjah piercing, piercing artist UAE, home piercing service, mobile piercing service, piercing appointment" />
      </Helmet>

        <div className="floating-buttons">
            <div className='whatsapp-button' onClick={() => handleWhatsAppClick("I am interested in Piercing")}>
            <img src={whatsapp} alt="WhatsApp" className="icon" />
            </div>
            <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" className="icon" />
            </a>

        </div>

      <div className="headingsection">
        <h1>Our Piercing Services</h1>
      </div>

      <div className="image-gallery2">
        <div className="image-card2" onClick={() => navigate("/earlobepiercing")}>
          <img src={Image1} alt="Ear Lobe piercing" />
          <div className="image-text2">
            <h3>Ear Lobe Piercing 100-125 AED</h3>
            <p>A classic and popular piercing done on the lower part of the ear lobe.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/earlobepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/babypiercing")}>
          <img src={Image2} alt="Baby Ear piercing" />
          <div className="image-text2">
            <h3>Baby Ear Piercing 150-200 AED</h3>
            <p>Safe and gentle ear piercing for babies, ensuring a quick and comfortable experience.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/babypiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/secondlobepiercing")}>
          <img src={Image3} alt="Second lobe Piercing" />
          <div className="image-text2">
            <h3>Second Lobe Piercing 100-125 AED</h3>
            <p>Add a second hole to your ear lobe for a chic and trendy style.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/secondlobepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/upperlobepiercing")}>
          <img src={Image4} alt="Upper lobe Piercing" />
          <div className="image-text2">
            <h3>Upper Lobe Piercing 100-125 AED</h3>
            <p>Stylish piercing on the upper part of the ear lobe, great for layering.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/upperlobepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/highlobepiercing")}>
          <img src={Image5} alt="High lobe Piercing" />
          <div className="image-text2">
            <h3>High Lobe Piercing 100-125 AED</h3>
            <p>A piercing placed higher up on the ear lobe for a unique look.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/highlobepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/stacklobepiercing")}>
          <img src={Image6} alt="Stacklobe Piercing" />
          <div className="image-text2">
            <h3>Stacklobe Piercing 100-200 AED</h3>
            <p>A multiple lobe piercing stacked closely together for a statement look.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/stacklobepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/nosepiercing")}>
          <img src={Image7} alt="Nose Piercing" />
          <div className="image-text2">
            <h3>Nose Piercing 150 AED</h3>
            <p>A timeless piercing that adds a touch of elegance to your nose.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/nosepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/doublenosepiercing")}>
          <img src={Image8} alt="Double Nose Piercing" />
          <div className="image-text2">
            <h3>Double Nose Piercing 250 AED</h3>
            <p>A bold choice, perfect for making a striking visual statement.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/doublenosepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/bellypiercing")}>
          <img src={Image9} alt="Belly Piercing" />
          <div className="image-text2">
            <h3>Belly Piercing 200-250 AED</h3>
            <p>A sexy and bold belly button piercing for a standout look.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/bellypiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>

        <div className="image-card2" onClick={() => navigate("/tonguepiercing")}>
          <img src={Image10} alt="Tongue Piercing" />
          <div className="image-text2">
            <h3>Tongue Piercing 200 AED</h3>
            <p>A bold piercing for those who want to express their individuality.</p>
            <button
              className="know-more-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/tonguepiercing");
              }}
            >
              Know More
            </button>
          </div>
        </div>
        <div className="image-card2" onClick={() => navigate("/septumpiercing")}>
        <img src={Image11} alt="Septum piercing" />
        <div className="image-text2">
          <h3>Septum Piercing 150-200 AED</h3>
          <p>A stylish and edgy piercing through the septum, perfect for a unique look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/septumpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/smiliepiercing")}>
        <img src={Image12} alt="Smiley Piercing" />
        <div className="image-text2">
          <h3>Smiley Piercing 150-200 AED</h3>
          <p>A hidden piercing inside the upper lip, only visible when you smile.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/smiliepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/eyebrowpiercing")}>
        <img src={Image13} alt="Eyebrow Piercing" />
        <div className="image-text2">
          <h3>Eyebrow Piercing 150-175 AED</h3>
          <p>A bold piercing through the eyebrow for a strong statement look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/eyebrowpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/traguspiercing")}>
        <img src={Image14} alt="Tragus Piercing" />
        <div className="image-text2">
          <h3>Tragus Piercing 150 AED</h3>
          <p>A delicate piercing on the small cartilage in front of the ear canal.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/traguspiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/doubletraguspiercing")}>
        <img src={Image15} alt="Double Tragus Piercing" />
        <div className="image-text2">
          <h3>Double Tragus Piercing 250 AED</h3>
          <p>Two piercings on the tragus for a bold and layered look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/doubletraguspiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/industrialpiercing")}>
        <img src={Image16} alt="Industrial Piercing" />
        <div className="image-text2">
          <h3>Industrial Piercing 175-200 AED</h3>
          <p>A double cartilage piercing connected by a single barbell for a striking look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/industrialpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/helixpiercing")}>
        <img src={Image17} alt="Helix Piercing" />
        <div className="image-text2">
          <h3>Helix Piercing 150-175 AED</h3>
          <p>A popular cartilage piercing placed along the upper ear for a stylish look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/helixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/doublehelixpiercing")}>
        <img src={Image18} alt="Double Helix Piercing" />
        <div className="image-text2">
          <h3>Double Helix Piercing 250 AED</h3>
          <p>A layered cartilage piercing, adding a second hole for extra edge.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/doublehelixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/midhelixpiercing")}>
        <img src={Image19} alt="MidHelix Piercing" />
        <div className="image-text2">
          <h3>MidHelix Piercing 150 AED</h3>
          <p>A mid-ear cartilage piercing, ideal for a balanced and chic look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/midhelixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/triplehelixpiercing")}>
        <img src={Image20} alt="Triple Helix Piercing" />
        <div className="image-text2">
          <h3>Triple Helix Piercing 300 AED</h3>
          <p>A bold triple-layer cartilage piercing for a standout look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/triplehelixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/hiddenhelixpiercing")}>
        <img src={Image21} alt="Hidden Helix piercing" />
        <div className="image-text2">
          <h3>Hidden Helix Piercing 150-200 AED</h3>
          <p>A subtle and stylish helix piercing that stays hidden behind the ear.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/hiddenhelixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/forwardhelixpiercing")}>
        <img src={Image22} alt="Forward Helix Piercing" />
        <div className="image-text2">
          <h3>Forward Helix Piercing 150 AED</h3>
          <p>A stylish forward helix piercing located on the outer rim of the ear.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/forwardhelixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/doubleforwardhelixpiercing")}>
        <img src={Image23} alt="Double Forward Helix Piercing" />
        <div className="image-text2">
          <h3>Double Forward Helix 250 AED</h3>
          <p>A double-layered forward helix piercing for a unique look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/doubleforwardhelixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/tripleforwardhelixpiercing")}>
        <img src={Image24} alt="Triple Forward Helix Piercing" />
        <div className="image-text2">
          <h3>Triple Forward Helix 350 AED</h3>
          <p>A bold triple-layer forward helix piercing for a standout look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/tripleforwardhelixpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/rookpiercing")}>
        <img src={Image25} alt="Rook Piercing" />
        <div className="image-text2">
          <h3>Rook Piercing 150-175 AED</h3>
          <p>A trendy cartilage piercing located in the anti-helix of the ear.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/rookpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/fauxrookpiercing")}>
        <img src={Image26} alt="Faux Rook piercing" />
        <div className="image-text2">
          <h3>Faux Rook Piercing 150-175 AED</h3>
          <p>A surface-level piercing mimicking the rook style without cartilage involvement.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/fauxrookpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/flatpiercing")}>
        <img src={Image27} alt="Flat Piercing" />
        <div className="image-text2">
          <h3>Flat Piercing 150-175 AED</h3>
          <p>A piercing on the flat area of the ear, perfect for studs and small hoops.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/flatpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/doubleflatpiercing")}>
        <img src={Image28} alt="Double Flat piercing" />
        <div className="image-text2">
          <h3>Double Flat Piercing 300 AED</h3>
          <p>A double-layered flat piercing for an edgier look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/doubleflatpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/tripleflatpiercing")}>
        <img src={Image29} alt="Triple Flat piercing" />
        <div className="image-text2">
          <h3>Triple Flat Piercing 300 AED</h3>
          <p>A bold triple flat piercing, ideal for a layered and modern look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/tripleflatpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/daithpiercing")}>
        <img src={Image30} alt="Daith Piercing" />
        <div className="image-text2">
          <h3>Daith Piercing 150-200 AED</h3>
          <p>A stylish piercing through the innermost cartilage fold of the ear, known for its unique placement.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/daithpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/snakebitemidipiercing")}>
        <img src={Image31} alt="Snake bite midi" />
        <div className="image-text2">
          <h3>Snake Bite Midi 200 AED</h3>
          <p>A bold piercing for an edgy snake bite look on the lip.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/snakebitemidipiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/conchpiercing")}>
        <img src={Image32} alt="Conch Piercing" />
        <div className="image-text2">
          <h3>Conch Piercing 150-175 AED</h3>
          <p>A unique inner-ear piercing perfect for hoops and studs.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/conchpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/contraconchpiercing")}>
        <img src={Image33} alt="Contra Conch Piercing" />
        <div className="image-text2">
          <h3>Contra Conch Piercing 175 AED</h3>
          <p>A stylish piercing opposite the conch for a striking look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/contraconchpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/orbitalpiercing")}>
        <img src={Image34} alt="Orbital Piercing" />
        <div className="image-text2">
          <h3>Orbital Piercing 200 AED</h3>
          <p>A unique double piercing connected by a single ring.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/orbitalpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/snugpiercing")}>
        <img src={Image35} alt="Snug Piercing" />
        <div className="image-text2">
          <h3>Snug Piercing 200 AED</h3>
          <p>An uncommon and bold ear piercing located on the inner cartilage.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/snugpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/surfacetraguspiercing")}>
        <img src={Image36} alt="Surface Tragus Piercing" />
        <div className="image-text2">
          <h3>Surface Tragus Piercing 350 AED</h3>
          <p>A surface-level piercing on the tragus for a unique style.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/surfacetraguspiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/antitraguspiercing")}>
        <img src={Image37} alt="Anti-Tragus Piercing" />
        <div className="image-text2">
          <h3>Anti-Tragus Piercing 250 AED</h3>
          <p>A bold piercing opposite the tragus for an edgy look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/antitraguspiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/lippiercing")}>
        <img src={Image38} alt="Lip Piercing" />
        <div className="image-text2">
          <h3>Lip Piercing 150-200 AED</h3>
          <p>A versatile lip piercing, perfect for studs or rings.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/lippiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/lipsnakebitepiercing")}>
        <img src={Image39} alt="Lip Snake Bite Piercing" />
        <div className="image-text2">
          <h3>Lip Snake Bite Piercing 300 AED</h3>
          <p>A popular double lip piercing mimicking a snake bite.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/lipsnakebitepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/ashleypiercing")}>
        <img src={Image40} alt="Ashley Lip Piercing" />
        <div className="image-text2">
          <h3>Ashley Lip Piercing 200 AED</h3>
          <p>A unique lip piercing placed in the center of the lower lip.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/ashleypiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/medusalippiercing")}>
        <img src={Image41} alt="Medusa Lip Piercing" />
        <div className="image-text2">
          <h3>Medusa Lip Piercing 200 AED</h3>
          <p>A stylish piercing located in the center of the upper lip, often adorned with a stud.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/medusalippiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/monroelippiercing")}>
        <img src={Image42} alt="Monroe Lip Piercing" />
        <div className="image-text2">
          <h3>Monroe Lip Piercing 200 AED</h3>
          <p>A chic piercing placed above the upper lip, resembling Marilyn Monroe's iconic beauty mark.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/monroelippiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/verticallabretlippiercing")}>
        <img src={Image43} alt="Vertical Labret Lip Piercing" />
        <div className="image-text2">
          <h3>Vertical Labret Lip Piercing 250 AED</h3>
          <p>A unique vertical piercing that adds flair to the lip area, perfect for those who want something different.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/verticallabretlippiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/cheekdimplepiercing")}>
        <img src={Image44} alt="Cheek Dimple Piercing" />
        <div className="image-text2">
          <h3>Cheek Dimple Piercing 200-250 AED</h3>
          <p>A playful piercing that mimics natural dimples, adding a touch of charm to your smile.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/cheekdimplepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/tonguewebpiercing")}>
        <img src={Image45} alt="Tongue Web Piercing" />
        <div className="image-text2">
          <h3>Tongue Web Piercing 250 AED</h3>
          <p>A unique piercing located under the tongue, perfect for those seeking something subtle yet eye-catching.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/tonguewebpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/snakeeyetonguepiercing")}>
        <img src={Image46} alt="Snake Eye Tongue Piercing" />
        <div className="image-text2">
          <h3>Snake Eye Tongue Piercing 250 AED</h3>
          <p>A daring piercing that resembles snake eyes, offering a bold look on the tongue.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/snakeeyetonguepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/nipplepiercing")}>
        <img src={Image47} alt="Nipple Piercing" />
        <div className="image-text2">
          <h3>Nipple Piercing 200-250 AED</h3>
          <p>A popular body piercing that enhances the aesthetics of the nipple area, often styled with rings or barbells.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/nipplepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/chestdermalpiercing")}>
        <img src={Image48} alt="Chest Dermal Piercing" />
        <div className="image-text2">
          <h3>Chest Dermal Piercing 450 AED</h3>
          <p>A stunning surface piercing on the chest, offering a unique way to adorn the skin.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/chestdermalpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/chestsurfacepiercing")}>
        <img src={Image49} alt="Chest Surface Piercing" />
        <div className="image-text2">
          <h3>Chest Surface Piercing 400-500 AED</h3>
          <p>A decorative surface piercing on the chest that allows for creative jewelry placement.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/chestsurfacepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/fingerdermalpiercing")}>
        <img src={Image50} alt="Finger Dermal" />
        <div className="image-text2">
          <h3>Finger Dermal 450 AED</h3>
          <p>A trendy piercing on the finger, perfect for those looking for something unique.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/fingerdermalpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/facedermalpiercing")}>
        <img src={Image51} alt="Face Dermal Piercing" />
        <div className="image-text2">
          <h3>Face Dermal Piercing 500 AED</h3>
          <p>A stylish piercing located on the face, adding a unique flair to your look.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/facedermalpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/handwristdermalpiercing")}>
        <img src={Image52} alt="Hand Wrist Dermal" />
        <div className="image-text2">
          <h3>Hand Wrist Dermal 450 AED</h3>
          <p>A trendy dermal piercing on the wrist, perfect for those who love unique body art.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/handwristdermalpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/backdimpledermalpiercing")}>
        <img src={Image53} alt="Back Dimple Dermal Piercing" />
        <div className="image-text2">
          <h3>Back Dimple Dermal Piercing 800 AED</h3>
          <p>A striking piercing placed in the back dimples, enhancing your natural curves.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/backdimpledermalpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/napepiercing")}>
        <img src={Image54} alt="Nape Piercing" />
        <div className="image-text2">
          <h3>Nape Piercing 450 AED</h3>
          <p>A unique piercing at the nape of the neck, perfect for adding a touch of elegance.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/napepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/collarbonepiercing")}>
        <img src={Image55} alt="Collarbone Piercing" />
        <div className="image-text2">
          <h3>Collarbone Piercing 450 AED</h3>
          <p>An eye-catching piercing that adorns the collarbone, perfect for showcasing jewelry.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/collarbonepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/microdermalpiercing")}>
        <img src={Image56} alt="Micro Dermal Piercing" />
        <div className="image-text2">
          <h3>Micro Dermal Piercing 500 AED</h3>
          <p>A subtle dermal piercing that adds a delicate touch to your body art collection.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/microdermalpiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

      <div className="image-card2" onClick={() => navigate("/intimatepiercing")}>
        <img src={Image57} alt="Intimate Piercing" />
        <div className="image-text2">
          <h3>Intimate Piercing 500 AED</h3>
          <p>Intimate piercing is ideal for individuals seeking a personalized and unique form of body modification that enhances both confidence and self-expression.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/intimatepiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>

            <div className="image-card2" onClick={() => navigate("/bugadipiercing")}>
        <img src={Image58} alt="Bugadi Piercing" />
        <div className="image-text2">
          <h3>Bugadi Piercing 150 AED</h3>
          <p>At our piercing studio, safety, hygiene, and comfort are our top priorities.</p>
          <button
            className="know-more-btn"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/bugadipiercing");
            }}
          >
            Know More
          </button>
        </div>
      </div>



      </div>

      <br/>

    </div>
  );
}

export default Services;
